var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"material-log"},[(_vm.isMounted)?_c('div',[_c('LogList',{ref:"logList",attrs:{"isModal":false,"title":_vm.logTitle,"itemName":_vm.logItemName,"reqPath":_vm.logReqPath,"filterValues":_vm.filterValues,"filters":_vm.tableFilterConfig},on:{"clearFilters":_vm.clearFilters}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }